import React from "react";

import ImageIcon from "@mui/icons-material/Image";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import BorderTopIcon from "@mui/icons-material/BorderTop";
import DescriptionIcon from "@mui/icons-material/Description";

const ResourceIcon = ({
    fileMimeType = null,
    size = "small",
    color = "",
    disabled = false,
}) => {
    let iconImage = "";

    switch (fileMimeType) {
        case "image/tiff":
        case "image/jpeg":
        case "image/png":
            iconImage = (
                <ImageIcon
                    title="Image resource"
                    fontSize={size}
                    color={color}
                />
            );
            break;

        case "application/pdf":
            iconImage = (
                <PictureAsPdfIcon
                    title="PDF resource"
                    fontSize={size}
                    color={color}
                />
            );
            break;

        case "application/vnd.oasis.opendocument.spreadsheet":
        case "application/vnd.ms-excel":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            iconImage = (
                <BorderTopIcon
                    title="Doc resource"
                    fontSize={size}
                    color={color}
                />
            );
            break;

        case "text/csv":
            iconImage = (
                <BorderTopIcon
                    title="Text resource"
                    fontSize={size}
                    color={color}
                />
            );
            break;

        default:
            iconImage = (
                <DescriptionIcon
                    title="Resource"
                    fontSize={size}
                    color={color}
                />
            );
            break;
    }

    return iconImage;
};

export default ResourceIcon;
